import { render, staticRenderFns } from "./CharacteristicNew.vue?vue&type=template&id=780c5fc6&"
import script from "./CharacteristicNew.vue?vue&type=script&lang=js&"
export * from "./CharacteristicNew.vue?vue&type=script&lang=js&"
import style0 from "./CharacteristicNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports